export default "__VITE_ASSET__DSHlveUf__"